/**
 * Creates a memoized version of a function that caches results based on JSON-stringified arguments.
 *
 * @param fn - The function to memoize.
 * @returns A memoized version of the function that caches results.
 */
export const memoize = (fn) => {
    const cache = {};
    return (...args) => {
        const stringifiedArgs = JSON.stringify(args);
        const result = (cache[stringifiedArgs] = cache[stringifiedArgs] || fn(...args));
        return result;
    };
};
